import { Pipe, PipeTransform } from '@angular/core';
import {dateToString, dateTimeToString, ajustarFusoDinamico} from '../../../utils/date';
import {isNullOrUndefined} from '../../../utils/util';
import momentTz from 'moment-timezone';

@Pipe({
    name: 'data'
})
export class DataPipe implements PipeTransform {

    transform(value: any, args?: any): any {
        return dateToString(value);
    }
}

@Pipe({
    name: 'datetime'
})
export class DateTimePipe implements PipeTransform {

    transform(value: any, args?: any): any {
        return dateTimeToString(value);
    }
}

@Pipe({
	name: 'datetimeIgnorarFusoLocal'
})
export class DateTimeIgnorarFusoLocalPipe implements PipeTransform {
	transform(value: any, args?: any): any {
		if (!isNullOrUndefined(value)) {
			const serverTimezone = 'America/Sao_Paulo';
			return momentTz.tz(value, serverTimezone).format('DD/MM/YYYY HH:mm:ss');
		}
		return '';
	}
}


@Pipe({
	name: 'ajustarFusoDinamico'
})
export class AjustarFusoDinamicoPipe implements PipeTransform {
	transform(value: string | Date): string {
		return ajustarFusoDinamico(value);
	}
}
